// Same display rule as the PDF: cap huge ratios, hide a percent on a thin last-year base.
const YOY_CAP = 500;
const YOY_MIN_LY_TN = 20;

function signedPct(value) {
  const n = Number(value);
  const rounded = Math.round(Math.abs(n));
  if (rounded === 0) return { body: '0%', tone: 'muted' };
  const txt = rounded > YOY_CAP ? `>${YOY_CAP}%` : `${rounded}%`;
  return n > 0 ? { body: `↑ ${txt}`, tone: 'up' } : { body: `↓ ${txt}`, tone: 'down' };
}

function isFiniteNumber(value) {
  return value != null && value !== '' && Number.isFinite(Number(value));
}

/**
 * Season Summary vs-last-year cell model.
 * kind: 'pct' (exact label), 'approx' (label changed, compared on shared cultivars),
 * 'new' (no comparable lots last season), 'none' (no comparison available).
 * Missing or unknown basis behaves like legacy sidecars (exact yoy_pct only).
 */
export function formatSeasonYoy({ yoyPct, yoyBasis, yoyFamilyPct, tonnesLy } = {}) {
  if (yoyBasis === 'new') {
    return { kind: 'new', text: 'New', tone: 'muted' };
  }
  if (yoyBasis === 'family' && isFiniteNumber(yoyFamilyPct)) {
    const { body, tone } = signedPct(yoyFamilyPct);
    return { kind: 'approx', text: `${body} ≈`, tone };
  }
  const thinBase =
    (yoyBasis === 'label' || yoyBasis == null || yoyBasis === '') &&
    isFiniteNumber(tonnesLy) &&
    Number(tonnesLy) >= 0 &&
    Number(tonnesLy) < YOY_MIN_LY_TN;
  if (thinBase || yoyBasis === 'none' || !isFiniteNumber(yoyPct)) {
    return { kind: 'none', text: '—', tone: 'muted' };
  }
  const { body, tone } = signedPct(yoyPct);
  return { kind: 'pct', text: body, tone };
}
